import { axios, base } from '../http';

export const getScreenDeviceList = (params) => axios.post(`${base}/api/ScreenDeviceAdmin/GetDeviceList`, params);

export const getScreenDeviceOptions = (params) => axios.get(`${base}/api/ScreenDeviceAdmin/GetDeviceOptions`, { params });

export const saveScreenDevice = (params) => axios.post(`${base}/api/ScreenDeviceAdmin/SaveDevice`, params);

export const deleteScreenDevice = (params) => axios.post(`${base}/api/ScreenDeviceAdmin/DeleteDevice`, null, { params });

export const setScreenDeviceEnabled = (params) => axios.post(`${base}/api/ScreenDeviceAdmin/SetEnabled`, params);

export const getAxdSchoolConfig = (params) =>
  axios.get(`${base}/api/axdSync/GetAxdSchoolConfig`, { params });

/** 保存学校奥讯达配置 */

export const saveAxdSchoolConfig = (params) =>
  axios.post(`${base}/api/axdSync/SaveAxdSchoolConfig`, params);

/** 测试奥讯达连通性（getToken） */

export const testAxdConnection = (params) =>
  axios.post(`${base}/api/axdSync/TestAxdConnection`, params);

/** 奥讯达同步统计 */

export const getAxdDeptStats = (params) =>
  axios.get(`${base}/api/axdSync/GetAxdDeptStats`, { params });

export const getAxdStudentStats = (params) =>
  axios.get(`${base}/api/axdSync/GetAxdStudentStats`, { params });

export const getAxdParentStats = (params) =>
  axios.get(`${base}/api/axdSync/GetAxdParentStats`, { params });

/** 奥讯达同步统计明细分页 */

export const getAxdDeptDetailPage = (params) =>
  axios.post(`${base}/api/axdSync/GetAxdDeptDetailPage`, params);

export const getAxdStudentDetailPage = (params) =>
  axios.post(`${base}/api/axdSync/GetAxdStudentDetailPage`, params);

export const getAxdParentDetailPage = (params) =>
  axios.post(`${base}/api/axdSync/GetAxdParentDetailPage`, params);

/** 异步同步年级与班级到奥讯达（仅学校节点） */

export const syncAllSubDeptToAxd = (params) =>
  axios.post(`${base}/api/axdSync/SyncAllSubDeptToAxd`, params);

/** 异步同步学生到奥讯达 */

export const syncAllSubDeptStudentToAxd = (params) =>
  axios.post(`${base}/api/axdSync/SyncAllSubDeptStudentToAxd`, params);

/** 异步同步家长到奥讯达 */

export const syncAllSubDeptParentToAxd = (params) =>
  axios.post(`${base}/api/axdSync/SyncAllSubDeptParentToAxd`, params);

/** 从奥讯达删除本地已不存在的年级/班级映射 */

export const deleteSubDeptFromAxd = (params) =>
  axios.post(`${base}/api/axdSync/DeleteSubDeptFromAxd`, params);

/** 从奥讯达删除本地已不存在的学生映射 */

export const deleteSubDeptStudentFromAxd = (params) =>
  axios.post(`${base}/api/axdSync/DeleteSubDeptStudentFromAxd`, params);

/** 从奥讯达删除本地已不存在的家长映射 */

export const deleteSubDeptParentFromAxd = (params) =>
  axios.post(`${base}/api/axdSync/DeleteSubDeptParentFromAxd`, params);

/** 明细单条同步到奥讯达 */

export const syncAxdDeptItem = (params) =>
  axios.post(`${base}/api/axdSync/SyncAxdDeptItem`, params);

export const syncAxdStudentItem = (params) =>
  axios.post(`${base}/api/axdSync/SyncAxdStudentItem`, params);

export const uploadAxdStudentPhotoItem = (params) =>
  axios.post(`${base}/api/axdSync/UploadAxdStudentPhotoItem`, params);

export const syncAxdParentItem = (params) =>
  axios.post(`${base}/api/axdSync/SyncAxdParentItem`, params);

/** 明细单条从奥讯达删除 */

export const deleteAxdDeptItem = (params) =>
  axios.post(`${base}/api/axdSync/DeleteAxdDeptItem`, params);

export const deleteAxdStudentItem = (params) =>
  axios.post(`${base}/api/axdSync/DeleteAxdStudentItem`, params);

export const deleteAxdParentItem = (params) =>
  axios.post(`${base}/api/axdSync/DeleteAxdParentItem`, params);

/** 奥讯达部门同步日志 */

export const getAxdDeptSyncLogPage = (params) =>
  axios.post(`${base}/api/axdSync/GetAxdDeptSyncLogPage`, params);

export const getAxdDeptSyncLog = (params) =>
  axios.get(`${base}/api/axdSync/GetAxdDeptSyncLog`, { params });

export const getAxdDeptSyncLogDetailPage = (params) =>
  axios.post(`${base}/api/axdSync/GetAxdDeptSyncLogDetailPage`, params);

export const deleteAxdDeptSyncLog = (params) =>
  axios.post(`${base}/api/axdSync/DeleteAxdDeptSyncLog`, params);

/** 奥讯达学生同步日志 */

export const getAxdStudentSyncLogPage = (params) =>
  axios.post(`${base}/api/axdSync/GetAxdStudentSyncLogPage`, params);

export const getAxdStudentSyncLog = (params) =>
  axios.get(`${base}/api/axdSync/GetAxdStudentSyncLog`, { params });

export const getAxdStudentSyncLogDetailPage = (params) =>
  axios.post(`${base}/api/axdSync/GetAxdStudentSyncLogDetailPage`, params);

export const deleteAxdStudentSyncLog = (params) =>
  axios.post(`${base}/api/axdSync/DeleteAxdStudentSyncLog`, params);

/** 奥讯达家长同步日志 */

export const getAxdParentSyncLogPage = (params) =>
  axios.post(`${base}/api/axdSync/GetAxdParentSyncLogPage`, params);

export const getAxdParentSyncLog = (params) =>
  axios.get(`${base}/api/axdSync/GetAxdParentSyncLog`, { params });

export const getAxdParentSyncLogDetailPage = (params) =>
  axios.post(`${base}/api/axdSync/GetAxdParentSyncLogDetailPage`, params);

export const deleteAxdParentSyncLog = (params) =>
  axios.post(`${base}/api/axdSync/DeleteAxdParentSyncLog`, params);

// ===== 表彰称号 =====
/** 分页查询表彰称号列表 */

export const getCameraPersonSyncStats = (params) =>
  axios.get(`${base}/api/CameraPersonSync/GetStats`, { params });
/** 分页查询部门脸库明细记录 */

export const getCameraGroupDetailPage = (params) =>
  axios.get(`${base}/api/CameraPersonSync/GetGroupDetailPage`, { params });
/** 分页查询人员同步明细记录 */

export const getCameraPersonDetailPage = (params) =>
  axios.get(`${base}/api/CameraPersonSync/GetPersonDetailPage`, { params });
/** 发起部门脸库同步 (年级分类) */

export const syncCameraGroups = (params) =>
  axios.post(`${base}/api/CameraPersonSync/SyncGroups`, params);
/** 发起人员人脸同步 (学生与教师) */

export const syncCameraPersons = (params) =>
  axios.post(`${base}/api/CameraPersonSync/SyncPersons`, params);
/** 发起删除设备上的部门脸库 (年级分类) */

export const deleteCameraGroup = (params) =>
  axios.post(`${base}/api/CameraPersonSync/DeleteGroup`, params);
/** 发起删除设备上的人员人脸 */

export const deleteCameraPersons = (params) =>
  axios.post(`${base}/api/CameraPersonSync/DeletePersons`, params);

/** 根据学校获取摄像头列表 */

export const getKqtCameraSyncLogPage = (params) =>
  axios.get(`${base}/api/CameraPersonSync/GetKqtCameraSyncLogPage`, { params });
/** 根据主日志 ID 分页获取明细记录列表 */

export const getKqtCameraSyncLogDetailPage = (params) =>
  axios.get(`${base}/api/CameraPersonSync/GetKqtCameraSyncLogDetailPage`, { params });

/** 发起真实物理设备的审计查询指令 */

export const queryDevicePhysical = (params) =>
  axios.get(`${base}/api/CameraPersonSync/QueryDevicePhysical`, { params });

/** 单次等待摄像头 MQTT 响应，用于在线检测，避免前端短轮询 */
export const probeDevicePhysical = (params) =>
  axios.get(`${base}/api/CameraPersonSync/QueryDevicePhysical`, {
    params: { ...params, waitForResponse: true, responseWaitSeconds: 8 }
  });

/** 前端低开销短轮询获取物理查询的数据包结果 */

export const getQueryStatus = (params) =>
  axios.get(`${base}/api/CameraPersonSync/GetQueryStatus`, { params });

// ─── 报修故障类型 ─────────────────────────────────────────────────
/** 获取故障类型列表（PC 管理） */
